import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { DocumentClarificationResponseDto } from '@taxora-shared-common/util';

@Component({
  selector: 'lib-document-clarifications',
  templateUrl: './document-clarifications.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, FormsModule, TranslatePipe, ButtonModule, TextareaModule],
})
export class DocumentClarifications {
  readonly clarifications = input<DocumentClarificationResponseDto[]>([]);
  readonly isSending = input<boolean>(false);
  readonly submitLabel = input<string>('Trimite clarificare');
  readonly placeholder = input<string>('Scrie un mesaj...');

  readonly send = output<string>();

  protected readonly message = signal('');

  protected readonly sortedClarifications = computed(() =>
    [...this.clarifications()].sort(
      (a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    ),
  );

  protected readonly canSend = computed(() => this.message().trim().length > 0);

  protected onSend(): void {
    const msg = this.message().trim();
    if (!msg) return;
    this.send.emit(msg);
    this.message.set('');
  }
}
